export enum WarningLevel {
  Green = 0,
  Yellow = 1,
  Orange = 2,
  Red = 3,
}

/** i18n key suffix for each level; prepend "code." to use with t(). */
export const warningLevelI18nKey = {
  [WarningLevel.Green]: "code.green",
  [WarningLevel.Yellow]: "code.yellow",
  [WarningLevel.Orange]: "code.orange",
  [WarningLevel.Red]: "code.red",
} as const satisfies Record<WarningLevel, string>;

export const warningLevelColorMap: Record<WarningLevel, string> = {
  [WarningLevel.Green]: "transparent",
  // Remove later when new color is tested and approved
  // [WarningLevel.Yellow]: "#F9E100",
  [WarningLevel.Yellow]: "#FFED00",
  // Remove later when new color is tested and approved
  // [WarningLevel.Orange]: "#E17000",
  [WarningLevel.Orange]: "#FF9900",
  // Remove later when new color is tested and approved
  // [WarningLevel.Red]: "#D52B1E",
  [WarningLevel.Red]: "#CD0000",
};

export function normalizeWarningLevel(level: number): WarningLevel {
  if (level === WarningLevel.Red) return WarningLevel.Red;
  if (level === WarningLevel.Orange) return WarningLevel.Orange;
  if (level === WarningLevel.Yellow) return WarningLevel.Yellow;
  return WarningLevel.Green;
}
